import { Injectable } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { SiteTheme, SiteThemeServiceInterface } from './site-theme.service.interface';

@Injectable({
  providedIn: 'root',
})
export class SiteThemeService implements SiteThemeServiceInterface {
  constructor(private readonly firestore: Firestore) {}

  async getTheme(site: string): Promise<SiteTheme | null> {
    const siteDocRef = doc(this.firestore, 'sites', site);
    const docSnapshot = await getDoc(siteDocRef);
    return (docSnapshot.get('medOption.liffConfig.theme') as SiteTheme | undefined) ?? null;
  }
}
